// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmAnchorNav = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			headerOffset: 110,
			headerOffsetMobile: 100,
			selector: '.anchor-nav__link',
			sticky: 'anchor-nav--sticky',
			$window: $(window)
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function ($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		methods.scrollWindow = function (element, speed) {
			var	position = $(element).position(),
					modifier = $(window).width() > 768 ? settings.headerOffset : settings.headerOffsetMobile

			$("html, body").animate({
				scrollTop: position.top - modifier
			}, speed);
		}

		// Bind events
		methods.events = function($context) {
			$context.find(settings.selector).off('click.lmAnchorNav').on('click.lmAnchorNav', function(event) {
				event.preventDefault();
				methods.scrollWindow($(this).attr('href'), 1000);
				window.location.hash = $(this).attr('href');
			});

			$(window).scroll(function () {
				if (settings.$window.width() > 768) {
					methods.testScrollPosition($context);
				}
			});
		}

		methods.testScrollPosition = function ($context) {
			var	position = $context.prev('.anchor-nav-placeholder').position();
			if (position){
				if (position.top <= $(window).scrollTop() + settings.headerOffset && !$context.hasClass(settings.sticky)) {
					$context.prev('.anchor-nav-placeholder').height($context.height());
					$context.addClass(settings.sticky);
				} else if (position.top > $(window).scrollTop() + settings.headerOffset && $context.hasClass(settings.sticky)) {
					$context.removeClass(settings.sticky);
					$context.prev('.anchor-nav-placeholder').removeAttr('style');
				}	
			}
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);

			if (window.location.hash) {
				methods.scrollWindow(window.location.hash, 200);
			}

			methods.events($context);

			if (settings.$window > 768) {
				methods.testScrollPosition($context);
			}
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('.anchor-nav').length) {
		$('.anchor-nav').lmAnchorNav();
	}

}(jQuery));